import { render, staticRenderFns } from "./LayoutBox.vue?vue&type=template&id=bf8ae54e&scoped=true&"
var script = {}
import style0 from "./LayoutBox.vue?vue&type=style&index=0&id=bf8ae54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8ae54e",
  null
  
)

export default component.exports